const hm = { hour: 'numeric', minute: 'numeric' };
const hma = Object.assign(Object.assign({}, hm), { hour12: true });
const hms = Object.assign(Object.assign({}, hm), { second: 'numeric' });
const hmsa = Object.assign(Object.assign({}, hms), { hour12: true });
const yd = { year: 'numeric', day: 'numeric' };
const ymd = Object.assign(Object.assign({}, yd), { month: 'numeric' });
const ymdMed = Object.assign(Object.assign({}, yd), { month: 'short' });
const ymdLong = Object.assign(Object.assign({}, yd), { month: 'long' });
const ymdFull = Object.assign(Object.assign({}, yd), { month: 'long', weekday: 'long' });
const options = {
    hm,
    hma,
    hms,
    hmsa,
    yd,
    ymd,
    ymdMed,
    ymdLong,
    ymdFull
};
export default Object.assign({}, options);
